<template>
    <top-menu/>
    <div id="app_body">
        <router-view></router-view>
    </div>
    <footer-display/>
</template>

<script>
    import TopMenu from '@/components/TopMenu'
    import FooterDisplay from '@/components/FooterDisplay'
    export default {
        name: 'App',
        components: {
            TopMenu,
            FooterDisplay
        }
    }
</script>

<style>
    body {
        margin: 0;
        padding: 0;
    }
    #app {
        position: relative;
        font-family: 'Roboto', sans-serif;
        min-height: 100vh;
    }

    #app_body {
        padding-top: 50px;
        min-height: calc(100vh - 100px);
    }
</style>
